export const DAY = 'day';
export const WEEK = 'week';
export const MONTH = 'month';
export const YEAR = 'year';
export const CUSTOM = 'custom';

const intervalTypes = [DAY, WEEK, MONTH, YEAR];
export const chooseIntervalList = [DAY, WEEK, MONTH, YEAR, CUSTOM];

export default intervalTypes;



// WEBPACK FOOTER //
// ./src/sources/constants/intervalTypes.js